/**
 * The investor's «Datos de riesgos» tab: each value is what the evaluation carries for it, as it came — V5's company
 * summary, read straight (driver, 2026-10-26). A value the evaluation does not carry is '' (never a '0', a 'S/ 0.00'
 * or a '$ 0.00' standing in for it), and the box shows V3's empty mark, '---'.
 */

const hasValue = (value: unknown): boolean => value !== null && value !== undefined && value !== '';

/** Anything with a `transform(value)` that spaces thousands, as `NumberSpacingPipe`. */
export interface AmountSpacing {
  transform(value: any): any;
}

/** One figure of the evaluation's criteria (`data`, or another attribute such as `others`), as text; '' when absent. */
export const riskCriterion = (evaluation: any, item: string, attribute = 'data'): string => {
  const value = evaluation?.criterias?.find((criterion) => criterion.item === item)?.[attribute];

  return hasValue(value) ? String(value) : '';
};

/** A criterion in soles — 'S/ 1 250 000.50'; '' when absent. */
export const riskSoles = (evaluation: any, item: string, spacing: AmountSpacing): string => {
  const value = riskCriterion(evaluation, item);

  return value === '' || isNaN(Number(value)) ? '' : 'S/ ' + spacing.transform(Number(value).toFixed(2));
};

/** The newest year of imports and exports the evaluation carries (V5 sends them newest first); undefined when it has none. */
const foreignTradeYear = (evaluation: any) => evaluation?.additionalInfo?.find((row) => hasValue(row?.year));

/** The year the imports and exports shown are of; '' when the evaluation carries none. */
export const riskForeignTradeYear = (evaluation: any): string => {
  const row = foreignTradeYear(evaluation);

  return row ? String(row.year) : '';
};

/** Imports or exports: dollars as '$ 45 000.00', an operations count as the count; '' when absent. */
export const riskForeignTrade = (evaluation: any, attribute: string, spacing: AmountSpacing): string => {
  const value = foreignTradeYear(evaluation)?.[attribute];
  if (!hasValue(value)) {
    return '';
  }

  if (attribute === 'importsOpsValue' || attribute === 'exportsOpsValue') {
    return String(value);
  }

  return isNaN(Number(value)) ? '' : '$ ' + spacing.transform(Number(value).toFixed(2));
};
